import { AttachmentRemoteDto } from 'src/generated/swagger';
import { Email } from './email';
import { EmailContact } from './email-contact';

export class EmailCreate {
   public static readonly type = '[Email] Create';

   constructor(public messageId: string, public email: Email, public attachments: AttachmentRemoteDto[] = []) {}
}

export class EmailReset {
   public static readonly type = '[Email] Reset';

   constructor(public messageId: string) {}
}

export class EmailAttachmentAdded {
   public static readonly type = '[Email] Add Attachment';

   constructor(public attachment: AttachmentRemoteDto, public messageId: string) {}
}

export class EmailAttachmentRemoved {
   public static readonly type = '[Email] Remove Attachment';

   constructor(public uid: string, public messageId: string) {}
}

export class ClearAttachments {
   public static readonly type = '[Email] Clear Attachments';

   constructor(public messageId: string) {}
}

export class EmailFieldValueUpdated {
   public static readonly type = '[Email] Update Email Field Value';

   constructor(public value: string, public messageId: string, public field: 'from' | 'subject' | 'body') {}
}

export class EmailContactFieldValueUpdated {
   public static readonly type = '[Email] Update Email Concact Field Value';

   constructor(public value: EmailContact[], public messageId: string, public field: 'to' | 'cc' | 'bcc') {}
}

export class DeleteEmailBehaviourState {
   public static readonly type = '[Email] Delete Behaviour State';

   constructor(public messageId: string) {}
}

export class UpdateValidation {
   public static readonly type = '[Email] Update Validation Enabled State';

   constructor(public messageId: string, public value: boolean) {}
}
